// Utilities to build a Material UI theme from saved branding settings
// and to keep CSS variables in sync for non-MUI styles.

import { createTheme } from '@mui/material/styles';

const DEFAULTS = {
  primaryColor: '#667eea',
  secondaryColor: '#764ba2',
  accentColor: '#f093fb',
};

export function readBranding() {
  try {
    const raw = localStorage.getItem('branding_settings');
    if (!raw) return { ...DEFAULTS };
    const json = JSON.parse(raw);
    return {
      primaryColor: json.primaryColor || DEFAULTS.primaryColor,
      secondaryColor: json.secondaryColor || DEFAULTS.secondaryColor,
      accentColor: json.accentColor || DEFAULTS.accentColor,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function applyCssVariables(branding) {
  if (typeof document === 'undefined') return;
  const b = branding || readBranding();
  document.documentElement.style.setProperty('--primary-color', b.primaryColor);
  document.documentElement.style.setProperty('--secondary-color', b.secondaryColor);
  document.documentElement.style.setProperty('--accent-color', b.accentColor);
}

export function buildMuiTheme(branding) {
  const b = branding || readBranding();
  return createTheme({
    palette: {
      mode: 'light',
      primary: { main: b.primaryColor },
      secondary: { main: b.secondaryColor },
      // Map accent to the info color so it is easily usable across MUI components
      info: { main: b.accentColor },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedInfo: {
            color: '#fff',
          },
        },
      },
    },
  });
}
